import RelatedMaterialBlock from './RelatedMaterialBlock';

export default RelatedMaterialBlock;